class Tooltip {
    constructor(element) {
        this.element = element
        this.tooltipWidth = 270
        this.initListeners();
        this.setTooltipPosition()
        $(this.element).find('.js-tooltip-content').removeClass('hidden')
    }

    setTooltipPosition() {
        const tooltipRect = this.element.getBoundingClientRect()
        const tooltipRightRect = document.documentElement.clientWidth - tooltipRect.right
        if (tooltipRightRect > this.tooltipWidth) {
            this.element.classList.remove('tooltip--left')
            this.element.classList.add('tooltip--right')
        } else {
            this.element.classList.remove('tooltip--right')
            this.element.classList.add('tooltip--left')
        }
    }

    initListeners() {
        this.initResizeListener()
    }

    initResizeListener() {
        window.addEventListener('resize', throttle(this.setTooltipPosition.bind(this), 200))
    }
}

window.addEventListener('load', function () {
    $('.js-tooltip').each((i, item) => new Tooltip(item))
})
